import { combineReducers } from "redux";
import { geofenceReducer } from "./geofence/reducers";
import { rmBuddiesReducer } from "./rm-buddies/reducers";

export const rootReducer = combineReducers({
  geofence: geofenceReducer,
  rmBuddies: rmBuddiesReducer
});
